import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class ServiceService extends ApiService {
  template = "defaultTemplate";
  namespace = "service";
  icon = "MoneyWithScissors";
  action = "action";
  favicon = "ReceiptWithMinus";
  name = "Discount";
  action_lable = this.t("Inactivate");
  inactive = 1;
  Width = 1200;
  DOMAIN = -32;
  search = true;
  singular = this.terminology.discount.singular;
  plural = this.terminology.discount.plural;
  vowel = this.terminology.discount.vowel;
  gemItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: PrimeIcons.LIST,
    },
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: "ReceiptWithMinus",
      field: "display_name",
    },
    {
      header: "Numbers",
      icon: "Shred",
      field: "Number",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Disable",
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this Good...",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: PrimeIcons.LOCK,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Good",
      icon: PrimeIcons.LIST,
    },
  ];
  constructor() {
    super("ar-discounts");
  }
}
